<div class="loading-container" style="display: flex; justify-content: center; align-items: center; height: 100vh; flex-direction: column;">
  <div class="spinner-border text-primary" role="status" style="width: 3rem; height: 3rem;">
    <span class="sr-only">Loading...</span>
  </div>
  <p style="margin-top: 20px; font-size: 1rem; color: #666;">새 상품을 준비하고 있습니다...</p>
</div>